import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
  AbstractControl,
  FormControl,
  FormGroup,
  ValidationErrors,
} from '@angular/forms';
import { TranslationService } from 'src/app/core/services/translation/translation.service';
import { minimumTrimmedLength } from 'src/app/shared/validators/registration-validators';

@Component({
  selector: 'app-notes-info-popup',
  templateUrl: './notes-info-popup.component.html',
  styleUrls: ['./notes-info-popup.component.scss'],
})

/**
 * Notes info popup component for activities feed
 */
export class NotesInfoPopupComponent implements OnInit {
  private static readonly NOTES_BLOCK_TEST = /['\\><=+@`{&]/;

  /**
   * Validator function to check if the Notes field contains restricted special characters.
   * validation error object `{ notesDisallowed: true }` when restricted
   * characters are present, otherwise returns `null`.
   *
   * @private
   * @param {AbstractControl} c - The form control being validated.
   * @return {ValidationErrors | null} - Validation error if restricted characters found, else null.
   */
  private static notesValidator(c: AbstractControl): ValidationErrors | null {
    const v = (c.value ?? '') as string;
    return NotesInfoPopupComponent.NOTES_BLOCK_TEST.test(v)
      ? { notesDisallowed: true }
      : null;
  }
  @Input() note?: string;
  @Input() canSave: boolean = false;
  @Input() viewOnly!: boolean;

  form = new FormGroup({
    note: new FormControl<string>('', [
      minimumTrimmedLength(3),
      NotesInfoPopupComponent.notesValidator,
    ]),
  });

  labels = {
    note: 'note',
    notes: 'notes',
    saveNote: 'save-note',
  };

  @Output() closeClick = new EventEmitter();
  @Output() saveClick = new EventEmitter();

  /**
   * Constructor
   */
  constructor(private readonly translationService: TranslationService) {}

  /**
   * Initiator
   */
  ngOnInit(): void {
    this.translationService.translateObject(this.labels);
    this.form.patchValue({ note: this.note });
  }

  /**
   * Triggers close click event
   */
  emitCloseClick() {
    this.closeClick.emit();
  }

  /**
   * Triggers save click event
   */
  emitSaveClick() {
    const note = this.form.controls.note.value?.trim().replace(/\s+/g, ' ');
    if (this.form.valid) {
      this.saveClick.emit(note);
    }
  }
}
